import get from 'lodash/get';
import { request } from 'client/modules/common/utils/request';
import { logInfo } from 'client/modules/common/utils/logInfo';

export interface DealFilterOption {
  value: number;
  label: string;
}

export interface DealFilterOptions {
  languageOptions: DealFilterOption[];
}

export function getDealFilterOptions(): Promise<DealFilterOptions> {
  return request({
    url: '/service/newsqueueservice/GetDealReviewFilterOptions',
    body: {},
  })
    .then(({ body }) => {
      const languages = get(body, 'options.languages', []) as Array<{
        idLanguage: number;
        language: string;
      }>;
      return {
        languageOptions: languages.map((lang) => ({
          value: lang.idLanguage,
          label: lang.language,
        })),
      } as DealFilterOptions;
    })
    .catch((error) => {
      logInfo({
        error,
        message: 'Deal Queue: Failed To Fetch Filter Options',
        method: 'getDealFilterOptions',
      });
      return { languageOptions: [] };
    });
}
